import { TInfrastructureType } from '../../../types/map';
import { IMainPromoPin } from '../../../types/newbuilding/mainPromoPin';

interface IParams {
  name: TInfrastructureType;
  mainPromoPin?: IMainPromoPin | null;
}
export function getPinSize({ name, mainPromoPin }: IParams) {
  if (mainPromoPin) {
    return 50;
  }

  return name === 'main' ? 54 : 32;
}
